import { ApiClassificationGroup, ApiProject } from "@incendium/api";
import { audienceService } from "Apis";
import { useProjectSharedState } from "./useSharedState";

const fetchClassificationGroups = async (project: ApiProject) => {
  const classificationGroups = await audienceService.audienceServiceListClassificationGroups({
    projectId: project.id as number,
  });
  return classificationGroups.results || [];
};

export const useClassificationGroups = () => {
  const { state, setState, loading } = useProjectSharedState(
    "classificationGroups",
    [],
    fetchClassificationGroups
  );

  return {
    classificationGroups: state as ApiClassificationGroup[],
    setClassificationGroups: setState,
    loading,
  };
};
